import {Component, OnInit, TemplateRef, ViewChild} from "@angular/core";
import {SiteServices} from "../../services/siteservices";
import {
    ArchieParameters,
    ArchiePredefinedFunction,
    ArchiePredefinedFunctionParameter, ArchieSavePredefinedFunctionDto,
    ArchieTrainingRule
} from "../../data/Entities";
import {BsModalRef, BsModalService} from "ngx-bootstrap";

@Component({
    selector: 'archieapp',
    templateUrl: '/templates/get/Archie/archie',
})
export class ArchieComponent implements OnInit {
    modalRef: BsModalRef;
    @ViewChild('savechangesmodal')
    private saveChangesTemplateRef: TemplateRef<any>;
    private archieParameters: ArchieParameters;
    private predefinedFunctions: Array<ArchiePredefinedFunction>;
    private selectedPredefinedFunction: ArchiePredefinedFunction;
    
    private showFunctionParameters: boolean;
    private showTrainingRules: boolean;
    private showLogs: boolean;
    private actionInProgress: boolean;
    private showDiv: boolean = false;
    
    private description: string;

    chatGptRoles: any = ['system', 'assistant', 'user'];
    private functionNameRegex = /^[a-zA-Z0-9_-]{1,64}$/;
    
    constructor(
        public siteServices: SiteServices,
        private modalService: BsModalService)
    {}
    
    ngOnInit() {
        this.actionInProgress = true;
        this.siteServices.archie_Execute(
            'GETVARIABLES',
            '',
            (data) => {
                if (data.TagObject) {
                    this.archieParameters = data.TagObject;
                }
            }
        );
        
        this.siteServices.archie_Execute(
            'GETPREDEFINEDFUNCTIONS',
            '',
            (data) => {
                if (data.TagObject) {
                    this.predefinedFunctions = data.TagObject;
                }
            }
        );
        
        this.actionInProgress = false;
    }

    toggleDiv() {
        this.showDiv = !this.showDiv;
    }

    saveChangesModal() {
        if (!this.isValidFunctionName() || !this.isValidFunctionDescription()) return;
        
        this.modalRef = this.modalService.show(this.saveChangesTemplateRef, {
            class: 'modal-md',
        });
    }
    
    saveSelectedPredefinedFunction() {
        if (!this.selectedPredefinedFunction.IsExtraLogicRequired) {
            this.selectedPredefinedFunction.FunctionExtraLogicTypeID = null;
        }
        
        this.actionInProgress = true;
        this.selectedPredefinedFunction.ArchiePredefinedFunctionLogs = null;
        
        const savePredefinedFunctionDto = new ArchieSavePredefinedFunctionDto();
        savePredefinedFunctionDto.ArchiePredefinedFunction = this.selectedPredefinedFunction;
        savePredefinedFunctionDto.Description = this.description;
        
        this.siteServices.archie_Execute(
            'SAVEPREDEFINEDFUNCTION',
            savePredefinedFunctionDto,
            (data) => {
                if (data.TagObject) {
                    this.predefinedFunctions = data.TagObject;
                    this.selectedPredefinedFunction = null;
                    this.showTrainingRules = this.showFunctionParameters = this.showLogs = false;
                    this.description = '';
                    this.actionInProgress = false;
                    this.siteServices.success('Ok');
                }
            }
        );

        this.modalRef.hide();
    }

    addNewPredefinedFunction() {
        this.selectedPredefinedFunction = new ArchiePredefinedFunction();        
    }

    deleteSelectedPredefinedFunction() {
        if (!confirm("Biztosan törlöd?")) return;
        
        this.actionInProgress = true;
        if (this.selectedPredefinedFunction.ArchiePredefinedFunctionID == null) {
            this.selectedPredefinedFunction = null;
            this.actionInProgress = false;
            return;
        }
        else {
            this.siteServices.archie_Execute(
                'DELETEPREDEFINEDFUNCTION',
                this.selectedPredefinedFunction.ArchiePredefinedFunctionID,
                (data) => {
                    if (data.TagObject) {
                        this.predefinedFunctions = data.TagObject;
                        this.selectedPredefinedFunction = null;
                        this.actionInProgress = false;
                    }
                }
            );
        }
    }

    removeFunctionParameter(index: number) {
        this.selectedPredefinedFunction.ArchiePredefinedFunctionParameterList.splice(index, 1);
    }

    removeTrainingRule(index: number) {
        this.selectedPredefinedFunction.ArchieTrainingRuleList.splice(index, 1);
    }
    
    addFunctionParameter() {
        if (!this.selectedPredefinedFunction.ArchiePredefinedFunctionParameterList) this.selectedPredefinedFunction.ArchiePredefinedFunctionParameterList = [];
        const newFunctionParameterItem = new ArchiePredefinedFunctionParameter();
        newFunctionParameterItem.ArchiePredefinedFunctionID = this.selectedPredefinedFunction.ArchiePredefinedFunctionID;
        this.selectedPredefinedFunction.ArchiePredefinedFunctionParameterList.push(newFunctionParameterItem);
    }
    
    addTrainingRule() {
        if (!this.selectedPredefinedFunction.ArchieTrainingRuleList) this.selectedPredefinedFunction.ArchieTrainingRuleList = [];
        const newTrainingRuleItem = new ArchieTrainingRule();
        newTrainingRuleItem.ArchiePredefinedFunctionID = this.selectedPredefinedFunction.ArchiePredefinedFunctionID;
        this.selectedPredefinedFunction.ArchieTrainingRuleList.push(newTrainingRuleItem);
    }
    
    toggleFunctionParameters() {
        this.showFunctionParameters = !this.showFunctionParameters;
    }
    
    toggleTrainingRules() {
        this.showTrainingRules = !this.showTrainingRules;
    }

    toggleLogs() {
        this.showLogs = !this.showLogs;
    }

    selectedPredefinedFunctionChanged(){
        this.showTrainingRules = this.showFunctionParameters = this.showLogs = false;
    }
    
    isValidFunctionName() : boolean {
        if (!this.selectedPredefinedFunction || 
            !this.selectedPredefinedFunction.FunctionName || 
            !this.selectedPredefinedFunction.FunctionName.trim()) return false;
        
        return this.functionNameRegex.test(this.selectedPredefinedFunction.FunctionName);
    }
    
    isValidFunctionDescription() : boolean {
        if (!this.selectedPredefinedFunction || 
            !this.selectedPredefinedFunction.FunctionDescription || 
            !this.selectedPredefinedFunction.FunctionDescription.trim()) return false;
        
        return true;
    }
}

